import { z } from 'zod/v4';
import { AmforiSupplierLastSyncedSchema } from '../schemas/supplier-last-synced.js';

/**
 * `GET /integrations/amfori/suppliers/last-synced` — bulk, brand-scoped list of
 * the `amfori_last_synced_at` value for every supplier in the caller's network
 * that has one. Always 200 with an array (empty when none) — never 404. The FE
 * merges these into the supplier-network list by `companyId`.
 */
export const ListAmforiSuppliersLastSyncedContract = {
  method: 'GET',
  path: '/integrations/amfori/suppliers/last-synced',
  response: z.array(AmforiSupplierLastSyncedSchema),
} as const;
